"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsPauseKeywords = exports.googleAdsPauseKeywordsResultSchema = exports.googleAdsPauseKeywordsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsPauseKeywordsInputSchema = zod_1.z
    .object({
    criterionResourceName: zod_1.z
        .string()
        .describe('The resource name of the keyword to pause (e.g., customers/123/adGroupCriteria/456~789)'),
})
    .describe('Pause a Google Ads keyword.');
exports.googleAdsPauseKeywordsArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsPauseKeywordsInputSchema);
var googleAdsPauseKeywordsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    resourceName: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
});
exports.googleAdsPauseKeywordsResultSchema = googleAdsPauseKeywordsResponseSchema;
exports.googleAdsPauseKeywords = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsPauseKeywords',
    displayName: 'Google Ads Pause Keywords',
    displayDescription: 'Pause a Google Ads keyword. The keyword will stop triggering ads but can be re-enabled later.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsPauseKeywordsArgsSchema,
}, googleAdsPauseKeywordsResponseSchema);
